import { SERVICE_MAP } from '@financial/service-origins';
import elementClosestPolyfill from 'element-closest';
import { GLOBAL_COMMON_LOGS_ENV, LogEnv } from '../utils/env.mjs';
import throwErrorIfSSR from '../utils/throwErrorIfSSR.mjs';

let GLOBAL_AU_INIT = false;
const setGlobalAU = flag => GLOBAL_AU_INIT = flag;
const GLOBAL_AU_PARAMS = {
  service: '',
  page: ''
};
const isEmpty = value => typeof value === 'undefined' || value === null || value === '';
const filterEmpties = raw => Object.entries(raw).reduce((result, _ref) => {
  let [key, value] = _ref;
  return {
    ...result,
    ...(!isEmpty(value) && {
      [key]: value
    })
  };
}, {});
let Platform = /*#__PURE__*/function (Platform) {
  Platform["Content"] = "CONTENT";
  return Platform;
}({});
let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "click";
  Action["View"] = "view";
  return Action;
}({});
const getAULogObject = (_ref2, action) => {
  let {
    service,
    page,
    area,
    code,
    element,
    step,
    customMap,
    platform
  } = _ref2;
  const overrideService = service || GLOBAL_AU_PARAMS.service;
  const overridePage = page || GLOBAL_AU_PARAMS.page;
  if (GLOBAL_COMMON_LOGS_ENV.env === LogEnv.dev) {
    /* eslint-disable no-console */
    if (!overrideService) {
      console.warn(`service가 없습니다. service: ${overrideService}`);
    }
    if (!overridePage) {
      console.warn(`page가 없습니다. service: ${overridePage}`);
    }
    if (!area) {
      console.warn(`area가 없습니다. area: ${area}`);
    }
    if (!code) {
      console.warn(`code가 없습니다. code: ${code}`);
    }
    if (!action) {
      console.warn(`action이 없습니다. code: ${action}`);
    }
    /* eslint-enable no-console */
  }
  const URL_AU = `${SERVICE_MAP[GLOBAL_COMMON_LOGS_ENV.env].TRACE}/trace/web`;
  const params = filterEmpties({
    service: overrideService,
    page: overridePage,
    area,
    code,
    action,
    element,
    step,
    customMap,
    platform
  });
  if (platform === Platform.Content && isEmpty(params.page)) {
    /**
     * platform=CONTENT 일때는, page 와 action 을 생략하지 않아야합니다.
     * See: https://oss.fin.navercorp.com/Product-Planning/Support-Platform-Plan/issues/11#issuecomment-1058478
     */
    params.page = 'page';
  }
  const queryString = Object.entries(params).map(_ref3 => {
    let [key, value] = _ref3;
    return `${key}=${typeof value === 'string' ? value : JSON.stringify(value)}`;
  }).join('&');
  return {
    queryString,
    params,
    URL_AU
  };
};
const sendAULog = (param, action) => {
  const {
    URL_AU,
    params,
    queryString
  } = getAULogObject(param, action);
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(URL_AU, new Blob([JSON.stringify(params)], {
        type: 'application/json'
      }));
    } else {
      // workaround sendBeacon
      new Image().src = URL_AU + `?${queryString}`;
    }
  } catch {
    // workaround sendBeacon
    new Image().src = URL_AU + `?${queryString}`;
  }
};
const globalAUHandler = event => {
  const eventTarget = event.target;
  const auTarget = eventTarget.closest('[data-au]');
  const service = auTarget?.getAttribute('data-au-service') || '';
  const page = auTarget?.getAttribute('data-au-page') || '';
  const [area, code] = (auTarget?.getAttribute('data-au') || '').split('.');
  const element = auTarget?.getAttribute('data-au-element') || '';
  const step = auTarget?.getAttribute('data-au-step') || '';
  const rawCustomMap = auTarget?.getAttribute('data-au-custom-map') || '';
  const platform = auTarget?.getAttribute('data-au-platform') || '';
  if (area && code) {
    let customMap = '';
    try {
      customMap = rawCustomMap ? JSON.parse(rawCustomMap) : '';
    } catch {}
    sendAULog(filterEmpties({
      service,
      page,
      area,
      code,
      element,
      step,
      customMap,
      platform
    }), Action.Click);
  }
};
const addGlobalAUHandler = () => {
  throwErrorIfSSR();
  if (GLOBAL_AU_INIT) {
    return;
  }
  setGlobalAU(true);
  elementClosestPolyfill(window);
  document.addEventListener('click', globalAUHandler, {
    capture: true
  });
  return () => {
    setGlobalAU(false);
    document.removeEventListener('click', globalAUHandler, {
      capture: true
    });
  };
};
const setAUService = service => {
  throwErrorIfSSR();
  GLOBAL_AU_PARAMS.service = service;
  return () => GLOBAL_AU_PARAMS.service = '';
};
const setAUPage = page => {
  throwErrorIfSSR();
  GLOBAL_AU_PARAMS.page = page;
  return () => GLOBAL_AU_PARAMS.page = '';
};

export { Action, Platform, addGlobalAUHandler, getAULogObject, sendAULog, setAUPage, setAUService };
